// @react-functional
import * as React from 'react';
import { connect } from 'react-redux';
import { StateType } from '../state/reducers';
import { defaultState as featuresDefaultState } from './reducers/features';

const mapStateToProps = ({ features }: StateType) => ({
  features:
    features && features.features && features.country
      ? features.features[features.country]
      : featuresDefaultState.features.fr,
});

export type StateProps = ReturnType<typeof mapStateToProps>;

type FeaturesType = StateType['features']['features']['fr'];

export type WithFeaturesPropsType = {
  isFeatureEnabled: (name: keyof FeaturesType) => boolean;
};

export const withFeatures = (feature: keyof FeaturesType | 'all') => <
  P extends object
>(
  Component: React.ComponentType<P>,
) =>
  connect(mapStateToProps)((props: { features: FeaturesType }) => {
    function isFeatureEnabled(name: keyof FeaturesType) {
      return props.features && props.features[name];
    }

    if (feature === 'all' || (props.features && props.features[feature])) {
      return (
        <Component {...(props as P)} isFeatureEnabled={isFeatureEnabled} />
      );
    }

    return null;
  });
